import { COLLAPSABLE_CONTENT_HOME_FAQ_VALUES } from "@/components/Collapsible/constants";
import ConsultationForm from "@/components/ConsultationForm/ConsultationForm";
import FAQSection from "@/components/FAQSection";

const ConsultationPage = () => {
  return (
    <div className="flex h-full min-h-screen w-full flex-col items-center bg-gray-100 pt-25 md:pt-45">
      <div className="flex w-full max-w-[910px] flex-col items-center gap-7.5 px-4 md:gap-15 md:px-0">
        <div className="flex w-full max-w-[600px] flex-col items-center gap-6 text-center md:max-w-none">
          <h1 className="text-dark w-full text-[30px] leading-[1.2] font-normal md:text-[44px]">
            Pasikonsultuokite su ekspertu
          </h1>
          <p className="text-dark w-full text-[16px] leading-[1.4] md:whitespace-nowrap md:text-[18px]">
            Sužinokite, kaip Telomera gali Jums padėti, užsiregistravę į nemokamą 15 min. konsultaciją.
          </p>
          <p className="text-dark w-full text-[16px] leading-[1.4] md:text-[18px]">
            Narystes atveriame ribotam skaičiui naujų narių, kad kiekvienam
            galėtume užtikrinti aukščiausio lygio priežiūrą.
          </p>
        </div>

        <div className="w-full pb-10 md:pb-20">
          <ConsultationForm />
        </div>
      </div>

      <div className="w-full">
        <FAQSection
          data={COLLAPSABLE_CONTENT_HOME_FAQ_VALUES.items}
          variant="white"
        />
      </div>
    </div>
  );
};

export default ConsultationPage;
